import React, { useState, useEffect, useRef } from "react";
import PageHeader from "../../components/PageHeader";
import { Typography, Container } from "@mui/material";
import "./Chat.css";
import Conversation from "./components/Conversation";
import ChatBox from "../../components/ChatBox/ChatBox";
import { userChats } from "../../apis";
import { io } from "socket.io-client";

const Chat = () => {
  const socket = useRef();
  const [chats, setChats] = useState([]);
  const [currentChat, setCurrentChat] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [sendMessage, setSendMessage] = useState(null);
  const [receivedMessage, setReceivedMessage] = useState(null);

  const user = JSON.parse(localStorage.getItem("user-info"));
  const userid = user.googleId ? user.googleId : user._id;
  useEffect(() => {
    const getChats = async () => {
      try {
        const { data } = await userChats(userid);
        setChats(data);
      } catch (error) {
        console.log(error);
      }
    };
    getChats();
  }, []);

  // Connect to Socket.io
  useEffect(() => {
    socket.current = io("https://ammanat-chat-socket.herokuapp.com");
    socket.current.emit("new-user-add", userid);
    socket.current.on("get-users", (users) => {
      setOnlineUsers(users);
    });
  }, []);

  // Send Message to socket server
  useEffect(() => {
    if (sendMessage !== null) {
      socket.current.emit("send-message", sendMessage);
    }
  }, [sendMessage]);

  // Get the message from socket server
  useEffect(() => {
    socket.current.on("recieve-message", (data) => {
      console.log(data);
      setReceivedMessage(data);
    });
  }, []);

  const checkOnlineStatus = (chat) => {
    const chatMember = chat.members.find((member) => member !== userid);
    const online = onlineUsers.find((user) => user.userId === chatMember);
    return online ? true : false;
  };

  return (
    <>
      <Container>
        <PageHeader crossIcon title="Chat" />
        <div className="Chat">
          {/* left side chat */}
          <div className="Left-side-chat">
            <div className="Chat-container">
              <h2 style={{ textAlign: "center" }}>Chats</h2>
              <div className="Chat-list">
                {chats.map((chat) => (
                  <div
                    onClick={() => {
                      setCurrentChat(chat);
                    }}
                  >
                    <Conversation
                      data={chat}
                      currentUser={userid}
                      online={checkOnlineStatus(chat)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Side */}

          <div className="Right-side-chat">
            <ChatBox
              chat={currentChat}
              currentUser={userid}
              setSendMessage={setSendMessage}
              receivedMessage={receivedMessage}
            />
          </div>
        </div>
      </Container>
    </>
  );
};

export default Chat;
